import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {NgStyle} from '@angular/common';
import {AchievementRowComponent} from '@components/achievement-row/achievement-row.component';
import {Title} from '@angular/platform-browser';
import {TranslatePipe} from '@ngx-translate/core';
import {LastVideosComponent} from '@components/last-videos/last-videos.component';
import {Member, MemberRole} from '@/app/core/models/member';
import {CalendarGroupByDate} from '@/app/core/models/calendar/calendarGroupByDate';
import {determineRoleIcon} from '@/app/core/utils/memberUtils';
import {environment} from '@/environments/environment';
import {TranslateDynamicService} from '@services/translate-dynamic.service';
import {SeparatorComponent, TitleComponent} from '@/app/shared';
import {UpcomingMatchsComponent} from '@components/upcoming-matchs/upcoming-matchs.component';

@Component({
	selector: 'app-roster-sportc',
	imports: [
		AchievementRowComponent,
		TranslatePipe,
		LastVideosComponent,
		NgStyle,
		TitleComponent,
		UpcomingMatchsComponent,
		SeparatorComponent,
	],
	templateUrl: './roster-sport.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./roster-sport.component.css']
})
export class RosterSportComponent {

	constructor(
		private readonly titleService: Title,
		protected readonly translateDynamicService: TranslateDynamicService
	) {}


}
